import React, { Component } from 'react';
import './scannerIcons.css';
class ScannerIcons extends Component {
  render() {
    return (
      <div>
        <svg viewBox="0 0 1920 1080.5">
          <defs>
            <filter id="luminosity-invert" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
              <feColorMatrix values="-1 0 0 0 1 0 -1 0 0 1 0 0 -1 0 1 0 0 0 1 0" />
            </filter>
            <mask id="mask" x="1868" y="194" width="20" height="888" maskUnits="userSpaceOnUse">
              <g className="scanner-icons-91">
                <image
                  width="20"
                  height="888"
                  transform="translate(1868 194)"
                  xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAN4CAIAAABMNV/mAAAACXBIWXMAAAsSAAALEgHS3X78AAAEWUlEQVR4Xu3RN0usWxTGcUvnI2htOxbHMYuxVPwEhtYEBsaEOYzWps4IRsQ0JtRmFAQDBjDnwgyKGDBhOA9z4eCr3gu3knv5r2q/e6/f2muv18Xlh8NkMrm5uXl4eJjNZi8vL19fX39//wBnaKHPX79+6UgJSlOyAWvL29s7MjIyJiYmISEhLS0tMzMz2xlWqzU1NVWbOlKCj4+Pu7u7AaukDpKSkkpKSqqrqxsaGlpbWzucoUV9fX1VVZWOlBAVFaVkA1ZLKqxjMbvd7nA4ZmZmFpyhhT4HBgZ0pITY2FhPT08D1jsTExNramok5+bmtre3j46OzpxxeHi4tbU1OzurIyXocovFYsB+fn4ZGRlNTU1TU1M7OzsXFxd3d3dPztBCn9rUkRKUpmQDDgwMzMnJ6ezsVJ+np6cPDw9vb2/vztBCn9pcXFzs6urKzc1VsgEHBwcXFBT09vaurq5eXl6+vLy8fwh9anNtba2vr6+wsDAkJMSAQ0NDi4uL9arNzc3r6+s/1/4Jberlg4ODmpmSDTgsLKy0tHRoaEijur29ff8S2tzd3R0ZGSkrK1PyZ6zd4eFhZWhCX/H9/f3e3t7o6Gh5eXl4eLgB61tYhf8B7+/vj42N2Wy2b7BKqrDKK+9bfHBwMD4+XlFRERER8e+w/tZ/F09MTPwcrqysBIPBYDAYDAaDwWAwGAwGg8FgMBgMBoPBYDAYDAaDwWAwGAwGg8FgMBgMBoPBYDAYDAaDwWAwGAwGg8FgMBgMBoPBYDAYDAaDwWAwGAwGg8FgMBgMBoPBYDAYDAaDwWAwGAwGg8FgMBgMBoPBYDAYDAaDwWAwGAwGg8FgMBgMBoPBYDAYDAaDwWAwGAwGg8FgMBgMBoPBYDAYDAaDwWAwGAwGg8FgMBgMBoPBYDAYDP5RXFFR8RN4fHz8/4PDwsLKyspGRkZ2d3fv7u6+YlXc398fGxuz2Wzf4NLS0uHh4Z2dnb/DauovrDYNODQ0tKSkZGhoaHt7+/b29itWRTWl1vS6zzgkJKSoqGhgYGBjY+P6+vrt7e0Tvrm5UV1VV4Nq04CDg4Pz8/N7enpWVlYuLy9fXl4+ytfX16urq/X19f7+ft2hmww4ICAgOzu7o6Njfn7+5OREL/x4+ePj49nZ2fLycnd3d15eXlBQkAH7+vqmp6c3NjZOTk6qvYuLC/mnp6fn52f9JPWiaU1PT7e0tFitVn9/fwP28vJKTEysrq622+2zs7NbW1tHR0e67fz8/Pj4WKNaWFjQv6irq0tOTrZYLAZsNptjYmI08IaGBo3N4XCoxOLi4tLS0tzc3NTUlEbV3NysUcfHx3t6ehqwh4dHZGRkUlKSvO5Xiba2ti5ntLe3NzU11dbWSqakpERHRyvZgN3c3Hx8fKKionS/+tf7s7KycnJycnNzNciMjAzVjYuLk9R03N3dDdhkMmlLJdW/3q8MzT/QGVr4+fnpnepWCUpzdXV1+eH4DXCcUY3s7Q0LAAAAAElFTkSuQmCC"
                />
              </g>
            </mask>
            <mask id="mask-2" x="1869" y="195" width="18" height="277" maskUnits="userSpaceOnUse">
              <g className="scanner-icons-91">
                <image
                  width="18"
                  height="277"
                  transform="translate(1869 195)"
                  xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAEVCAIAAABi3iIMAAAACXBIWXMAAAsSAAALEgHS3X78AAADuklEQVRoQ+3bx0vjWxQH8FnGv8CysyzESoyxk6IooltFsSBoBAVFFNEIIcYOomIZUeLoQrCXJGoUC6KbIIQgGiWxoyAJIpIYsWJmvvyy8ZeZEebxeA+Gc1b33pzPueWX7fny5X8IDofj7e3t7+8fEhLC5XL5fH4UExhgikX8hAQPDw8WwxIy0tLScnJyJBJJWVlZBRMYYIrF9PR0JPj4+LAYisGUlJTI5fLOzs6BgYFvTGCAaX19fWlpKWRAQACLhYaG5ubm4melUjk/P7+2trbFBAaYDg0NKRSKvLw8pLEYj8fDVj09PWq1WqfTHRwcnDCBAaZY7O3txYZIY7Ho6OjKysrh4WHsYDabrVbrHRMWiwXT7e3tkZGRqqqqmJgYFouPj6+trZ2YmNDr9dfX1w6H4/X19e3t7eHhAVODwTA5OSmVSpHGYgKBQCaTzc3NGY3G29tbgO9MYIApjqpSqfBaQqGQxTDHe2g0GpPJZLPZnE6ni2Fgt9uPjo4WFxcbGhpEIhGLicVirC4tLR0fH9/f33//EDjw6enp8vJyU1MT0txZY2OjVqvF6+E+H9nj4+PZ2dnKykpLS0tiYiKLYY5iKInCP7Pz8/PV1VWwpKQkd9bc3IySKOzGnp6eLi4u8N1bW1s/Yyj/r7H19fW2trY/Y5eXl8SIESNGjBgxYsSIESNGjBgxYsSIESNGjBgxYsSIESNGjBgxYsSIESNGjBgxYsSIESNGjBgxYsSIEfubmKvX6J+0KP22s+l37VefMbFYDKbVaj/v2kp0a/Zy9Yi5WsscDsdHhipnTI8YbuHORCKRQqFYWFgwm812u/0jQ5WTkxMc5BcdaUKhUC6Xq1Sqw8PDu7u79/d3l3E6nTabzWQyoSLquve/JSQk1NXVTU9P7+7uWq3W5+dnV+fcy8vLzc3N/v7+7OysTCYTCAQsFhsbW11dPTo6qtPp8ADY8IkJbIVvvbOzMzY2VlNTExcXx2J8Pr+8vHxwcBAPvbe3hxe3WCzY9urqymg0bmxsKJXKioqKqKgoFuNyuUVFRe3t7VNTU5ubm3q93siEwWDY2tqamZnp6OiQSCQREREsFhQUlJWVJZVK+/r6cB61Wr3MhEajGR8f7+/vx82zs7ODg4NZzM/PLyUlpbCwEBfAZ+3q6vrKRHd3N/7BKIezpKamIo3FPD09cYDk5OSMjIz8/Hycp4SJ4uLigoKCzMxMFOXxeEhjMQ6HgyVfX9/AwMCwsDCUQFJkZCQG4eHhuAL28fLycu83/Y/iB7IecjRTaZNtAAAAAElFTkSuQmCC"
                />
              </g>
            </mask>
            <symbol id="main_-_scanner-on" data-name="main - scanner-on" viewBox="0 0 26.02 26.02">
              <g id="scanner_icon_off-2" data-name="scanner_icon off">
                <circle className="scanner-icons-3" cx="13.01" cy="13.01" r="3.71" />
                <circle className="scanner-icons-3" cx="13.01" cy="13.01" r="8.17" />
                <circle className="scanner-icons-3" cx="13.01" cy="13.01" r="12.51" />
                <line className="scanner-icons-3" x1="13.01" y1="13.01" x2="13.01" y2="13.01" />
                <polyline className="scanner-icons-3" points="3.61 3.98 13.31 13.11 22.05 4.37" />
              </g>
            </symbol>
            <symbol id="sm_mag_glass" data-name="sm mag glass" viewBox="0 0 11.66 11.66">
              <path
                className="scanner-icons-7"
                d="M11.52,10.4,8.69,7.57A4.83,4.83,0,1,0,7.57,8.69l2.83,2.83a.71.71,0,0,0,1-.14A.71.71,0,0,0,11.52,10.4ZM1,4.8a3.8,3.8,0,1,1,3.8,3.8A3.8,3.8,0,0,1,1,4.8Z"
              />
            </symbol>
            <symbol id="arrow_down" data-name="arrow down" viewBox="0 0 8 6">
              <polygon
                id="drop_down_triangle"
                data-name="drop down triangle"
                className="scanner-icons-2"
                points="4 6 0 0 8 0 4 6"
              />
            </symbol>
            <symbol id="sort-on_down" data-name="sort-on down" viewBox="0 0 8.23 13.21">
              <polygon className="scanner-icons-9" points="0 7.91 4.11 13.21 8.23 7.91 0 7.91" />
              <polygon className="scanner-icons-7" points="0 5.3 4.11 0 8.23 5.3 0 5.3" />
            </symbol>
            <symbol id="sort-off" data-name="sort-off" viewBox="0 0 8.23 13.21">
              <polygon className="scanner-icons-7" points="0 7.91 4.11 13.21 8.23 7.91 0 7.91" />
              <polygon className="scanner-icons-7" points="0 5.3 4.11 0 8.23 5.3 0 5.3" />
            </symbol>
            <symbol id="sm_scroll_arrow_off" data-name="sm_scroll_arrow_off" viewBox="0 0 6 4">
              <path
                className="scanner-icons-8"
                d="M.18,2.8,2.34.29a.89.89,0,0,1,1.31,0L5.82,2.8A.74.74,0,0,1,5.17,4H.83A.74.74,0,0,1,.18,2.8Z"
              />
            </symbol>
            <symbol id="button_cancel_on" data-name="button_cancel_on" viewBox="0 0 124 20">
              <g id="button_off" data-name="button off">
                <rect className="scanner-icons-2" width="124" height="20" rx="3" ry="3" />
              </g>
            </symbol>
            <symbol id="stop_scanner" data-name="stop scanner" viewBox="0 0 11 11">
              <rect className="scanner-icons-1" width="11" height="11" />
            </symbol>
            <symbol id="action-restart-off" data-name="action-restart-off" viewBox="0 0 20 20">
              <path
                className="scanner-icons-1"
                d="M5.94.86l0,0A9.94,9.94,0,0,1,9.88,0h0l.65,0,.45,0h.07A9.92,9.92,0,0,1,15.8,1.88l1-1.44a.25.25,0,0,1,.45.1l.61,3.35.43,2.36a.25.25,0,0,1-.06.21.25.25,0,0,1-.19.09h0L15.35,6.4l-3-.16a.25.25,0,0,1-.16-.43l1.23-1.16a6.32,6.32,0,0,0-2.61-1v0a6.47,6.47,0,1,0,5.51,5.38L19.75,7.8A10,10,0,1,1,5.94.86Z"
              />
            </symbol>
            <symbol id="manual_scan_off" data-name="manual scan off" viewBox="0 0 26.02 35.14">
              <g id="scanner_icon_off-3" data-name="scanner_icon off">
                <path className="scanner-icons-4" d="M10.6,15.83a3.71,3.71,0,1,1,5.13-.3" />
                <path className="scanner-icons-4" d="M7.42,19a8.17,8.17,0,1,1,11.47-.28" />
                <path className="scanner-icons-4" d="M4.37,22.06A12.51,12.51,0,1,1,22,21.75" />
                <line className="scanner-icons-4" x1="13.01" y1="13.01" x2="13.01" y2="13.01" />
                <polyline className="scanner-icons-4" points="3.61 3.98 13.31 13.11 22.05 4.37" />
              </g>
              <line className="scanner-icons-4" x1="14.92" y1="23.15" x2="14.92" y2="26.2" />
              <line className="scanner-icons-4" x1="17.86" y1="23.99" x2="17.86" y2="26.61" />
              <path
                className="scanner-icons-5"
                d="M20.79,25.71V24c0-1.66-2.93-1.66-2.93,0v-.83c0-1.64-2.93-1.67-2.93,0V18.07c0-1.66-2.93-1.66-2.93,0V29.76s-1.85-5.48-4.07-4.32,3.6,7.82,4.81,9.39"
              />
              <path
                className="scanner-icons-4"
                d="M22.17,34.83a24.47,24.47,0,0,0,1.56-9.12c0-1.66-2.93-1.66-2.93,0v1.35"
              />
            </symbol>
            <symbol id="scanned_endpoint_on" data-name="scanned endpoint on" viewBox="0 0 28 32.08">
              <g id="scanner_icon_off-4" data-name="scanner_icon off">
                <circle className="scanner-icons-4" cx="14.17" cy="19.07" r="3.71" />
                <circle className="scanner-icons-4" cx="14.17" cy="19.07" r="8.17" />
                <circle className="scanner-icons-4" cx="14.17" cy="19.07" r="12.51" />
                <line className="scanner-icons-4" x1="14.17" y1="19.07" x2="14.17" y2="19.07" />
                <polyline className="scanner-icons-4" points="4.77 10.05 14.47 19.18 23.21 10.44" />
              </g>
              <circle className="scanner-icons-4" cx="1.5" cy="6.65" r="1.5" />
              <circle
                className="scanner-icons-4"
                cx="7.24"
                cy="2.83"
                r="1.5"
                transform="translate(1.86 8.44) rotate(-67.5)"
              />
              <circle
                className="scanner-icons-5"
                cx="14.01"
                cy="1.5"
                r="1.5"
                transform="translate(3.04 10.35) rotate(-45)"
              />
              <circle
                className="scanner-icons-5"
                cx="20.77"
                cy="2.86"
                r="1.5"
                transform="translate(0.49 8.17) rotate(-22.5)"
              />
              <circle className="scanner-icons-4" cx="26.5" cy="6.71" r="1.5" />
            </symbol>
          </defs>
        </svg>
      </div>
    );
  }
}

export default ScannerIcons;
